:root {
  --color-benefits: 253, 189, 154;

  --color-action-primary: #c3dedf;
  --color-action-primary-rgb: 195, 222, 223;
  --color-action-primary--bold: #99bfc0;
  --color-action-primary--disabled: rgba(var(--color-action-primary-rgb), 0.3);

  --color-action-text-primary: var(--color-grey-1);
  --color-action-text-primary--disabled: rgba(var(--color-grey-1-rgb), 0.2);
  --color-action-loader-primary: var(--color-grey-1);

  --color-action-secondary: #f8fbfc;
  --color-action-secondary-rgb: 248, 251, 252;
  --color-action-secondary--bold: #eff2f3;
  --color-action-secondary--disabled: rgba(
    var(--color-action-secondary-rgb),
    0.2
  );

  --color-action-text-secondary: var(--color-grey-1);
  --color-action-text-secondary--bold: var(--color-grey-1);
  --color-action-text-secondary--disabled: rgba(var(--color-grey-1-rgb), 0.2);
  --color-action-loader-secondary: var(--color-grey-1);

  --color-action-text-tertiary: var(--color-action-primary--bold);
  --color-action-text-tertiary--bold: var(--color-action-primary--bold);
  --color-action-text-tertiary--disabled: rgba(var(--color-grey-1-rgb), 0.2);
  --color-action-loader-secondary: var(--color-action-primary--bold);

  --color-selection--default: rgba(var(--color-action-primary-rgb), 0.5);
  --color-selection--active: var(--color-action-primary--bold);
  --color-selection--disable: var(--color-grey-5);
  --color-selection-text: var(--color-grey-1);

  --color-avatar-background: rgba(var(--color-benefits), 0.4);

  --color-step-border--current: #99bfc0;
  --color-step-border--disabled: #e2e3eb;
  --color-step-border--completed: #c3dedf;
  --color-step-border--warning: rgba(255, 170, 108, 0.2);
  --color-step-check-color: #fe766b;

  --color-file-preview-background: rgba(195, 222, 223, 0.1);
  --color-file-preview-border: #c3dedf;
  --color-file-preview-icon: rgba(195, 222, 223, 0.3);
  --color-file-preview-action: linear-gradient(
      0deg,
      rgba(130, 170, 171, 0.4),
      rgba(130, 170, 171, 0.4)
    ),
    #ffffff;

  --color-file-drop-background: linear-gradient(
      0deg,
      rgba(195, 222, 223, 0.4),
      rgba(195, 222, 223, 0.4)
    ),
    #f7f8fa;
}
